module.exports = __webpack_public_path__ + "assets/img/67_213_1.a91b8436.jpg";